import { ReactNode } from 'react';
interface IAnchor {
  content?: string;
  link: string;
  children?: ReactNode;
}

export const Anchor = ({ content, link, children }: IAnchor) => {
  return (
    <a
      className={'text-blue-350 font-medium text-s-18 sm:text-base '}
      href={link}
    >
      {content || children}
    </a>
  );
};
